import { gql } from '../../../apollo/__generated__';

export const JOIN_BEDROOM = gql(`
  mutation JoinBedroom($bedroomId: ID!, $eventId: ID!) {
    joinBedroom(bedroomId: $bedroomId, eventId: $eventId) {
      id
      floor
      doorNumber
      maxUsers
      users(eventId: $eventId) {
        id
        firstname
        lastname
        nickname
        studyTown
      }
    }
  }
`);
